import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";
Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		dark: true,
		themes: {
			dark: {
				primary: colors.cyan.lighten2
			}
		}
		// themes: {
		// 	dark: {
		// 		primary: "purple"
		// 	}
		// }
	},
	icons: {
		iconfont: "mdi"
	}
});
